// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { UIModelBaseElement } from './UIModelBaseElement';
import { ViewObject } from './ViewObject';
import { UIButton } from './UIButton';
import { ActionType } from './ActionType';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 操作 实体类
 * 对象视图操作，只有支持的操作，页面才能使用，一个操作可能对应多个View的多个按钮，自动同步，不能修改
 */
export class EVOAction extends UIModelBaseElement {
  /** 是否受控 : 不受控的操作，任何访问者都可见并可访问 */
  private _isControl: boolean;

  /** 设置：是否受控 */
  public get isControl() {
    return this._isControl;
  }

  /** 获取：是否受控 */
  public set isControl(value: boolean) {
    this._isControl = value;
  }

  /** 已移除 : 已移除的操作前端不可见 */
  private _removed: boolean;

  /** 设置：已移除 */
  public get removed() {
    return this._removed;
  }

  /** 获取：已移除 */
  public set removed(value: boolean) {
    this._removed = value;
  }

  /** 视图对象 的ID */
  private _viewObject_ID: string;

  /** 获取：视图对象 的ID */
  public get viewObject_ID() {
    return this._viewObject_ID;
  }

  /** 设置：视图对象 的ID */
  public set viewObject_ID(value: string) {
    this._viewObject_ID = value;
  }

  /** 视图对象  */
  private _viewObject: ViewObject;

  /** 获取：视图对象  */
  public get viewObject() {
    return this._viewObject;
  }

  /** 设置：视图对象  */
  public set viewObject(value: ViewObject) {
    this._viewObject = value;
    if (value !== null) {
      this.viewObject_ID = value.id;
    } else {
      this.viewObject_ID = '';
    }
  }

  /** 按钮 */
  private _buttons: Array<UIButton>;

  /** 获取：按钮 */
  public get buttons() {
    return this._buttons;
  }

  /** 设置：按钮 */
  public set buttons(value: Array<UIButton>) {
    this._buttons = value;
  }

  /** 操作类型 的ID */
  private _actionType_ID: string;

  /** 获取：操作类型 的ID */
  public get actionType_ID() {
    return this._actionType_ID;
  }

  /** 设置：操作类型 的ID */
  public set actionType_ID(value: string) {
    this._actionType_ID = value;
  }

  /** 操作类型  */
  private _actionType: ActionType;

  /** 获取：操作类型  */
  public get actionType() {
    return this._actionType;
  }

  /** 设置：操作类型  */
  public set actionType(value: ActionType) {
    this._actionType = value;
    if (value !== null) {
      this.actionType_ID = value.id;
    } else {
      this.actionType_ID = '';
    }
  }

  constructor() {
    super();
    this._isControl = false;
    this._removed = false;
    this._viewObject_ID = '';
    this._viewObject = null;
    this._buttons = new Array<UIButton>();
    this._actionType_ID = '';
    this._actionType = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: EVOAction, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isControl = element.isControl;
      this.removed = element.removed;
      this.viewObject_ID = element.viewObject_ID;
      if (hasReference && element.viewObject !== null) {
        this.viewObject = element.viewObject;
      }
      this.actionType_ID = element.actionType_ID;
      if (hasReference && element.actionType !== null) {
        this.actionType = element.actionType;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isControl = json.IsControl;
    this.removed = json.Removed;
    this.viewObject_ID = json.ViewObject_ID;
    // if (json.ViewObject !== null) {
    //   this.viewObject = ViewObject.Create(json.ViewObject);
    // }
    if (json.Buttons && json.Buttons.length > 0) {
      json.Buttons.forEach((element: any) => {
        const uIButton = UIButton.Create(element);
        // uIButton.action = this;
        this.buttons.push(uIButton);
      });
    }
    this.actionType_ID = json.ActionType_ID;
    // if (json.ActionType !== null) {
    //   this.actionType = ActionType.Create(json.ActionType);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsControl = this.isControl;
    json.Removed = this.removed;
    json.ViewObject_ID = this.viewObject_ID;
    if (this.buttons && this.buttons.length > 0) {
      json.Buttons = [];
      this.buttons.forEach((element) => {
        json.Buttons.push(element.toJson());
      });
    }
    json.ActionType_ID = this.actionType_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'isControl', '是否受控', EnumDataType.Bool, this.isControl, true, '不受控的操作，任何访问者都可见并可访问', '', '');
    context.addRow('基本属性', 'actionType', '操作类型', EnumDataType.Reference, this.actionType, true, '', 'ActionType', 'PGRowActionTypeValue');
    return context;
  }

  static Create(json: any): EVOAction {
    const eVOAction = new EVOAction();
    eVOAction.Deserialize(json);
    eVOAction.json = json;
    return eVOAction;
  }
}
